<template lang="pug">
    .animation(ref='animation')
        .grenade(ref='grenade')
            svg(width='100%' viewBox='-60 -20 302 289' preserveAspectRatio='xMidYMid meet')
                g(ref='check')
                    path(d='M90.1071 32.054H47.1895V57.8067H90.1071V32.054Z' fill='black')
                    path(d='M127.014 6.30127H38.6426V23.4697H115.04L121.097 25.9559L160.587 64.9367L163.123 71.0348V143.555H180.309V59.5423L127.014 6.30127Z' fill='black')
                g(transform='translate(90 100)')    
                    g(ref='light')
                        path(d='M30.8687 192.567L127.539 194.239L103.551 242.324L143.085 204.523L164.49 261.691L178.198 211.832L228.96 205.197L190.096 179.488L275.204 77.4392L175.473 121.779L190.676 74.3046L145.354 101.853L107.461 76.7864L121.732 161.632L30.8687 192.567Z' fill='#FF0000')
                path(d='M123.617 204.088L87.4151 242.057L68.431 246.472L48.1224 242.057L12.8031 204.088L7.50526 193.493L0.441406 147.136V137.865L7.50526 92.3914H18.984H99.7768H128.474L138.186 147.136L128.474 193.493L123.617 204.088Z' fill='white')
                path(d='M42.5417 92.0967C40.2878 107.717 39.02 123.478 38.7383 139.287H98.6071C98.3253 123.478 97.0575 107.717 94.8036 92.0967H42.5417Z' fill='black')
                path(d='M33.8549 92.0967H10.2361L7.79436 94.1137L0.1875 139.24H30.1454L33.8549 92.0967Z' fill='black')
                path(d='M30.0518 147.824H0L8.49902 195.014H33.9022L30.0518 147.824Z' fill='black')
                path(d='M103.023 66.907C103.023 66.7663 102.976 66.6256 102.835 66.4849C102.694 66.3442 102.6 66.2972 102.412 66.2972H34.8897C34.7489 66.2972 34.608 66.3442 34.4671 66.4849C34.3263 66.6256 34.2793 66.7194 34.2793 66.907V83.4657H102.976L103.023 66.907Z' fill='black')
                path(d='M42.542 195.014H94.8039L98.7012 147.824H38.5977L42.542 195.014Z' fill='black')
                path(d='M103.445 195.014H128.848L137.347 147.824H107.296L103.445 195.014Z' fill='black')
                path(d='M129.6 94.0669L127.158 92.0498H103.492L107.249 139.24H137.207L129.6 94.0669Z' fill='black')
                path(d='M87.3848 242.719L125.184 203.598H101.894L87.3848 242.719Z' fill='black')
                path(d='M44.2344 203.598L68.6514 246.472L93.0685 203.598H44.2344Z' fill='black')
                path(d='M12.209 203.598L50.0085 242.719L35.5461 203.598H12.209Z' fill='black')

</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('bottom-bottom', 'top-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});

            this.timeline
                .set(this.$refs.grenade, {x: '-100%'})
                .set(this.$refs.light, {scale: '0'})
                .fromTo(this.$refs.grenade, {x: '-100%'}, {duration: 1, x: '0'})
                .fromTo(this.$refs.check, {x: '0', y: '0', scale: 1, rotate: 0}, {duration: 2, x: '-100', y: '-50', scale: 0, rotate: -100}, 1)
                .fromTo(this.$refs.light, {scale: '0'}, {duration: 1, scale: 1, transformOrigin: '50% 50%'}, 2);
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss">
.animation {
    display: flex;
    align-items: center;
    justify-content: center;
}
.car {
    margin-bottom: 15px;
    img {
        display: block;
        width: 100%;
        height: auto;
    }
}
</style>
